import { render, staticRenderFns } from "./PresentationDetails.vue?vue&type=template&id=38e6ff32"
import script from "./PresentationDetails.vue?vue&type=script&lang=ts"
export * from "./PresentationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports